module.exports = __webpack_public_path__ + "static/media/logoutIcon.b18fa66e.svg";